module.exports = __webpack_public_path__ + "img/ce6a785606400e191bf439bcb83a05d8.42d6f17a.jpg";